import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";
import { defaultListMessages } from "../shared/crud/list";

export const messages = {
  ...defaultFormMessages,
  ...defaultListMessages,
  ...defineMessages({
    title: { id: "internalmenu.integrations.brandManager", defaultMessage: "Brand Manager" },
    brandTickerLabel: { id: "brandManager.label.brandTicker", defaultMessage: "Ticker brand" },
    brandNameLabel: { id: "brandManager.label.brandName", defaultMessage: "Translations" },
    managedByLabel: { id: "brandManager.label.managedBy", defaultMessage: "Manage by" },
    usedByLabel: { id: "brandManager.label.usedBy", defaultMessage: "Used by" },
    emailReceiverLabel: {
      id: "brandManager.label.emailReceiver",
      defaultMessage: "Email Receiver",
    },
    emailSenderLabel: { id: "brandManager.label.emailSender", defaultMessage: "Email Sender" },
    replyToEmailLabel: { id: "brandManager.label.replyToEmail", defaultMessage: "Reply to Email" },
    communicationPolicyLabel: {
      id: "brandManager.label.communicationPolicy",
      defaultMessage: "Política de comunicación",
    },
    privacyPolicyLabel: {
      id: "brandManager.label.privacyPolicy",
      defaultMessage: "Política de privacidad",
    },
    widgetLoyaltyLabel: {
      id: "brandManager.label.widgetLoyalty",
      defaultMessage: "Widget loyalty",
    },
    widgetUrlLabel: {
      id: "brandManager.label.widgetUrl",
      defaultMessage: "URL del widget",
    },
    widgetUrlHelp: {
      id: "brandManager.help.widgetUrl",
      defaultMessage:
        "URL del CNAME configurado en DNS para el widget (ej: wit-widgets.tudominio.com)",
    },
    idTierAgencyLabel: {
      id: "brandManager.label.idTierAgency",
      defaultMessage: "ID Tier agencia",
    },
    idTierCompanyLabel: {
      id: "brandManager.label.idTierCompany",
      defaultMessage: "ID Tier empresa",
    },
    enableEmailChangeLabel: {
      id: "brandManager.label.enableEmailChange",
      defaultMessage: "Permitir cambio de email",
    },
    sendWelcomeEmailLabel: {
      id: "brandManager.label.sendWelcomeEmail",
      defaultMessage: "Enviar email de bienvenida",
    },
    enableEmailChangeHelp: {
      id: "brandManager.help.enableEmailChange",
      defaultMessage:
        'Permitir al cliente editar su email de registro desde la sección "Mi cuenta".',
    },
    sendWelcomeEmailHelp: {
      id: "brandManager.help.sendWelcomeEmail",
      defaultMessage: "Enviar correo de bienvenida a nuevos usuarios registrados.",
    },
    useExternalTierLabel: {
      id: "brandManager.label.useExternalTier",
      defaultMessage: "Usar tier externo",
    },
    useExternalAuthSystemLabel: {
      id: "brandManager.label.useExternalAuthSystem",
      defaultMessage: "Usar sistema de autenticación externo",
    },
    brandTickerPlaceholder: {
      id: "brandManager.placeholder.brandTicker",
      defaultMessage: "Ticker brand",
    },
    managedByPlaceholder: { id: "brandManager.placeholder.managedBy", defaultMessage: "Manage by" },
    usedByPlaceholder: { id: "brandManager.placeholder.usedBy", defaultMessage: "Used by" },
    emptyFieldError: {
      id: "brandManager.error.emptyField",
      defaultMessage: "Este campo no puede estar vacío",
    },
    invalidEmailError: {
      id: "brandManager.error.invalidEmail",
      defaultMessage: "Revise este campo antes de guardar",
    },
    widgetLoyaltyValidationError: {
      id: "brandManager.error.widgetLoyaltyValidation",
      defaultMessage:
        "Si activa Widget Loyalty, debe completar TODOS los campos: URL, ID Tier Agencia e ID Tier Empresa",
    },
    loadBrandError: {
      id: "brandManager.error.loadBrand",
      defaultMessage: "Error al cargar la brand",
    },
  }),
};
